interface AmplienceIframePlaceholderProps {
  id: string;
  width?: number;
  height?: number;
  fullWidth?: boolean;
}

const AmplienceIframePlaceholder: React.FC<AmplienceIframePlaceholderProps> = ({
  id,
  width = 100,
  height,
  fullWidth = false,
}) => {
  const containerStyles: React.CSSProperties = {
    width: fullWidth ? '100vw' : `${width}%`,
    height: height ? `${height}px` : 'auto',
    marginLeft: fullWidth ? 'calc(-50vw + 50%)' : undefined,
    marginRight: fullWidth ? 'calc(-50vw + 50%)' : undefined,
    position: 'relative',
    display: 'block',
  };

  return <div id={id} style={containerStyles} role="presentation" data-testid="iframe-placeholder" />;
};

export default AmplienceIframePlaceholder;
